import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { OidcSecurityService } from 'angular-auth-oidc-client'

@Component({
    selector: 'app-auto-login',
    templateUrl: './auto-login.component.html',
    styleUrls: ['./auto-login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutoLoginComponent implements OnInit {
    private oidcSecurityService = inject(OidcSecurityService)

    ngOnInit() {
        localStorage.setItem('fromLogin', 'true')
        this.oidcSecurityService.authorize()
    }
}
